import { render, staticRenderFns } from "./PageMessageAll.vue?vue&type=template&id=1cc6fa42&scoped=true&"
import script from "./PageMessageAll.vue?vue&type=script&lang=js&"
export * from "./PageMessageAll.vue?vue&type=script&lang=js&"
import style0 from "./PageMessageAll.vue?vue&type=style&index=0&id=1cc6fa42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6fa42",
  null
  
)

export default component.exports